<template>
  <div class="container">
    <div class="meet-level trans">
      <meet-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">{{ hotel.name }}</h2>
        <div class="level-item shadow">
          <h2 class="dl-tit">酒店链接</h2>
          <div class="group">
            <p class="tips">{{ hotel.url }}</p>
          </div>
        </div>
        <div class="level-item shadow">
          <h2 class="dl-tit">酒店地址</h2>
          <div class="group">
            <p class="tips">{{ hotel.address }}</p>
          </div>
        </div>
        <div class="level-item shadow">
          <h2 class="dl-tit">酒店介绍</h2>
          <RichHtml class="group" style="margin-left:4px;margin-right:4px;" :content="this.hotel.introduction"></RichHtml>
        </div>
        <!-- <div class="level-item shadow">
                    <h2 class="dl-tit">地图</h2>
                    <div class="group">
                     
                    </div>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import meetHeader from "@/components/header"
  import RichHtml from "@/components/RichHtml"
  import { ConfHotel } from "@/store/entity/conferhotel"

  export default {
    name: "meetLevel",
    components: {
      meetHeader,
      RichHtml,
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "会议概况信息",
        },
        hotel: {},
      }
    },
    async created() {
      if (this.$route.params.hoteldetail) {
        this.hotel = this.$route.params.hoteldetail
      } else if (this.$route.query.hotel_id) {
        this.hotel = await ConfHotel.get_by_id(this.$route.query.hotel_id)
        console.log(this.hotel)
      }
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 18px;
      font-weight: bold;
      color: var(--main-color);
    }
    .level-item {
      padding: 15px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 5px;
      margin-top: 25px;

      .dl-tit {
        font-size: 16px;
        color: var(--main-color);
      }

      .group {
        margin-top: 10px;
      }

      .tips {
        font-size: 14px;
        color: #666;
        line-height: 30px;
      }
    }
  }
</style>
